import React from 'react';

import {
  Container,
  Data,
  DataRow,
  GaugeFill,
  GaugeTrack,
  Note,
  Title,
} from './styles';

interface FrequencyThermometerProps {
  percentage: number;
  activeCount: number;
  totalCount: number;
  onClick?: () => void;
}

// Substitui o antigo card "Membros Ativos" (que só mostrava a contagem
// crua) -- mesmo dado (`usersActiveInCurrentWeek`), só que como % do total
// de alunos com um gauge visual, em vez de duas versões separadas do mesmo
// número na tela.
const FrequencyThermometer: React.FC<FrequencyThermometerProps> = ({
  percentage,
  activeCount,
  totalCount,
  onClick,
}) => (
  <Container onClick={onClick} type="button">
    <Title>Frequência semanal</Title>
    <DataRow>
      <Data>{Math.round(percentage)}%</Data>
    </DataRow>
    <GaugeTrack>
      <GaugeFill percent={percentage} />
    </GaugeTrack>
    <Note>
      {activeCount} de {totalCount} alunos treinaram esta semana
    </Note>
  </Container>
);

export { FrequencyThermometer };
